/** Deliberate, keyboard-accessible exploration. Product capabilities never auto-cycle. */
export function initHomeExperience(): void {
  const explorer = document.querySelector<HTMLElement>('[data-grid-explorer]');
  if (explorer) {
    const tabs = Array.from(explorer.querySelectorAll<HTMLButtonElement>('[data-grid-step]'));
    const stage = explorer.querySelector<HTMLElement>('[data-explorer-stage]')!;
    const transmit = (): void => {
      stage.classList.remove('is-transmitting');
      void stage.offsetWidth;
      stage.classList.add('is-transmitting');
    };
    new IntersectionObserver(([entry], observer) => {
      if (entry.isIntersecting) { transmit(); observer.disconnect(); }
    }, { threshold: .25 }).observe(stage);
    const select = (index: number, focus = false): void => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        explorer.querySelector<HTMLElement>(`#grid-panel-${i}`)!.hidden = i !== index;
        const image = explorer.querySelector<HTMLImageElement>(`[data-explorer-image="${i}"]`)!;
        image.hidden = i !== index;
        image.classList.toggle('is-entering', i === index);
      });
      stage.dataset.explorerStage = String(index);
      transmit();
      if (focus) tabs[index]?.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
      tab.addEventListener('keydown', (event) => {
        let next = i;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      });
    });
  }

  const scene = document.querySelector<HTMLElement>('[data-ambient-scene]');
  if (!scene) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;
  const sync = (): void => {
    scene.classList.toggle('is-ambient-running', visible && !document.hidden && !reduced.matches);
  };
  new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }, { threshold: .1 }).observe(scene);
  reduced.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  sync();
}
